import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, useParams } from "react-router-dom";
import { createContainerApi, createEmailTemplate, createPackageApi, createShipmentTypeDurationApi, createShippingAPi, getPackageSizeApi, searchUmbrellaApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage, clearSelectedShipDuration } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";
const AddUmbrella = () => {
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const navigate = useNavigate()
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [expectedDate, setExpectedDate] = useState("");




    const [ordersData, setOrdersData] = useState()


    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);




    const [containerId, setContainerId] = useState('')

    const [loading, setLoading] = useState(false)

    const [selectedUnit, setSelectedUnit] = useState("AIR");

    // const [selectedOrderUnit, setSelectedUnit] = useState("AIR");








    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true)


        const payloadData = {


            shipment_type: selectedUnit,

            startDate: new Date(startDate)?.toISOString(),
            endDate: new Date(endDate)?.toISOString(),
            status: "RECEIVED"





        }

        try {
            const res = await searchUmbrellaApi(payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            setOrdersData(res)

            // navigate("/shipment-duration")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }

        finally {
            setLoading(false)
        }


    };

    // const dateArray = [new Date(expectedDate)?.toISOString()];



    const createContainer = async () => {
        // e.preventDefault();

        // setLoading(true)


        const payloadData = {


            selectedShipment: selectedUnit,
            expected_date: [new Date(expectedDate).toISOString()],
            orderStatus: "SHIPPED",
            selectedOrders:selectedOrders,
            containerId:containerId,






        }

        try {
            const res = await createContainerApi(payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            // setOrdersData(res)

            navigate("/umbrella-managemnt")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }

        finally {
            // setLoading(false)
        }


    };









    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedOrders([]);
        } else {
            setSelectedOrders(ordersData.map(order => order.id));
        }
        setSelectAll(!selectAll);
    };

    const handleSelectOne = (id) => {
        const newSelected = selectedOrders.includes(id)
            ? selectedOrders.filter(orderId => orderId !== id)
            : [...selectedOrders, id];

        setSelectedOrders(newSelected);

        // Automatically handle the selectAll checkbox
        if (newSelected.length === ordersData.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    };




    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Umbrella Management</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>

                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='containerId'>
                                        Create Container ID
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='containerId'
                                        placeholder='Enter Container Id'
                                        value={containerId}
                                        onChange={(e) => setContainerId(e.target.value)}
                                    />
                                </div>



                            </div>

                            <div className="row">
                                {/* Start Date */}
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='start-date'>
                                        Select Start Date
                                    </label>
                                    <input
                                        type='date'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='start-date'
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>

                                {/* End Date */}
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='end-date'>
                                        Select End Date
                                    </label>
                                    <input
                                        type='date'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='end-date'
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>

                                {/* Expected Date */}
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='expected-date'>
                                        Select Expected Date
                                    </label>
                                    <input
                                        type='date'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='expected-date'
                                        value={expectedDate}
                                        onChange={(e) => setExpectedDate(e.target.value)}
                                    />
                                </div>
                            </div>








                            <div className="row">

                                <div className="col-md-6 col-12">

                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeName'>

                                        Select Shipment Type
                                    </label>

                                    <div className="dropdown">
                                        <button
                                            className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {selectedUnit}
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("AIR")}
                                                >
                                                    AIR
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"

                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("SHIP")}
                                                >
                                                    SHIP
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                            </div>



                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2 col-12' disabled={loading && true}>
                                {loading ? "Searching...." : " Search Orders"}
                            </button>
                        </form>


                        <div className="card basic-data-table mt-16">

                            <div className="card-header d-flex flex-row justify-content-between align-items-center">
                                <h5 className="card-title mb-0">All Orders</h5>





                            </div>

                            <div className="card-body">

                                <div className="table-responsive">
                                    <table
                                        className="table vertical-striped-table mb-0"
                                    // id="dataTable"

                                    >
                                        <thead>
                                            <tr>


                                                {ordersData?.length > 0 &&


                                                <th scope='col'>
                                                    <div className="form-check style-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="checkAll"
                                                            checked={selectAll}
                                                            onChange={handleSelectAll}
                                                        />
                                                    </div>
                                                </th> }


                                                
                                                {/* <th scope="col">Date</th> */}
                                                <th scope="col">Order ID </th>

                                                <th scope="col">Shipment Type</th>
                                                <th scope="col">Full Name</th>
                                                <th scope="col">	Mobile Number</th>
                                                <th scope="col">	Email</th>
                                                <th scope="col">		Order Amount</th>
                                                <th scope="col">	Insurance Charges</th>





                                            </tr>
                                        </thead>
                                        <tbody>

                                            {ordersData?.length > 0 ? (


                                                ordersData?.map((order) => (
                                                    <tr key={order.id}>

                                                        <td>
                                                            <div className="form-check style-check d-flex align-items-center">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={selectedOrders.includes(order.id)}
                                                                    onChange={() => handleSelectOne(order.id)}
                                                                />
                                                            </div>
                                                        </td>

                                                        {/* <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">

                                                                    {formatDate(order?.createdAt)}
                                                                </h6>
                                                            </div>
                                                        </td> */}


                                                        <td>
                                                            <h6 className="text-md mb-0 fw-normal">      #{order?.display_id}</h6>
                                                            <span className="text-sm text-secondary-light fw-normal">
                                                                {formatDate(order.createdAt)}
                                                            </span>
                                                        </td>



                                                        <td>
                                                            <span style={{ width: "90%", margin: "auto" }}
                                                                className={`${order?.shipment_type === "AIR"
                                                                    ? "bg-success-focus text-success-main"
                                                                    : "bg-warning-focus text-warning-main"
                                                                    } px-24 py-4 rounded-pill fw-medium text-sm d-flex align-items-center gap-2 justify-content-center`}
                                                            >
                                                                {order?.shipment_type === "AIR" ? (
                                                                    <>
                                                                        <Icon icon="mdi:airplane" width="16" height="16" />
                                                                        Air
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Icon icon="mdi:ferry" width="16" height="16" />
                                                                        Ship
                                                                    </>
                                                                )}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">

                                                                    {order?.user?.fullname}
                                                                </h6>
                                                            </div>
                                                        </td>



                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                    {order?.user?.mobilenumber ? order?.user?.mobilenumber : "-"}

                                                                </h6>
                                                            </div>
                                                        </td>


                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                    {order?.user?.email ? order?.user?.email : "-"}

                                                                </h6>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">
                                                                    ${order?.grandTotal}

                                                                </h6>
                                                            </div>
                                                        </td>










                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="text-md mb-0 fw-medium flex-grow-1">

                                                                    {order?.insuranceCharges > 0 ? order?.insuranceCharges : "-"}
                                                                </h6>
                                                            </div>
                                                        </td>











                                                    </tr>
                                                ))


                                            ) : (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-16 text-muted">
                                                        No Orders found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>




                            </div>
                        </div>

                        {selectedOrders.length > 0 && (
                            <div className="row mt-16 gap-12">
                             

                                <div>
                                    <button className='btn btn-primary-600 radius-8 col-md-2 col-12'  onClick={()=>createContainer()}>
                                        { "Create Container"}
                                    </button>
                                </div>
                            </div>
                        )}



                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default AddUmbrella;
